import React, { PropTypes, Component } from 'react'
import styled from 'styled-components'
import Map from '../../components/Map'
import { Metrics } from '../../Themes'

const Container = styled.div`
  height: calc(100vh - ${Metrics.components.navbarDefault});
  width: 100vw;
  overflow: hidden;
  position: relative;

  @media screen and (max-width: ${Metrics.breakpoints.mobile}) {
    height: calc(100vh - ${Metrics.components.navbarDefault});
    margin-top: ${Metrics.margins.base};
  }
`

class FavoriteMap extends Component {
  render () {
    const { user, propertyDetails } = this.props
    return (
      <Container>
        <Map
          initialCenter={{
            lat: 0,
            lng: 0
          }}
          places={user.preferredProperties}
          handleSelect={propertyDetails}
        />
      </Container>
    )
  }
}

FavoriteMap.propTypes = {
  user: PropTypes.object,
  propertyDetails: PropTypes.func
}

export default FavoriteMap



// WEBPACK FOOTER //
// ./src/pages/Favorite/FavoriteMap.js